// extracted by mini-css-extract-plugin
export default {"header":"sLPaOa","collapsed":"WTk_ik","title-section":"nZpj2A","title-heading":"SmGNgF","collapse-button":"OnEOc5","title":"EtbjaN"};